import _ from "lodash";

const splitAndCapitaliseString = (text: string, splitter: string) => {
  return text.split(splitter).map(word => {
    return _.startCase(word);
  }).join(" ");
};

export default splitAndCapitaliseString;